import API_URLS from "../../config/BackendConfig";
import { getToken } from "../../utils/tokenUtils";
import { postRequest } from "../../config/AxiosConfig";

const prodBaseUrl = API_URLS.PROD;
const apiBaseUrl = API_URLS.CUSTOMER;

// Utility to get authorization headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Fetch Profile Data
export const fetchProfile = async () => {
    try {
      const response = await postRequest({
        url: apiBaseUrl + "profile",
        headers: getAuthHeaders(), // Ensure headers are correctly applied
      });
      return response;
    } catch (error) {
      console.error('Error fetching profile:', error.response?.data || error.message);
      throw error;
    }
  };

// Generate OTP for Aadhar Send OTP
export const generateAadharOtp = async ({ api_id, api_key, token_id, aadhar, methodName}) => {
  try {
    const payload = {
       "api_id": api_id,
      "api_key": api_key,
      "token_id": token_id,
      "aadhar": aadhar,
      "methodName": methodName,
    };

    const response = await postRequest({
        url: `${prodBaseUrl}aadhar/verification`,
      headers: getAuthHeaders(),
      data: payload,
    });

 
    return response;
  } catch (error) {
    console.error("Error generating OTP:", error.response?.data || error.message);
    throw error;
  }
};

// Verify Aadhar 
export const verifyAadharWithOtp = async ({ api_id, api_key, token_id, aadhar, methodName, client_id, otp }) => {
  try {
    const payload = {
        "api_id": api_id,
        "api_key": api_key,
        "token_id": token_id,
        "aadhar": aadhar,
        "methodName": methodName,
        "client_id": client_id,
        "otp": otp,
    };

    const response = await postRequest({
        url: `${prodBaseUrl}aadhar/verification`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error verifying Aadhar with OTP:", error.response?.data || error.message);
    throw error;
  }
};

// Generate OTP for AadharV2 Send OTP
export const generateAadharOtpV2 = async ({ api_id, api_key, token_id, aadhar, methodName}) => {
  try {
    const payload = {
       "api_id": api_id,
      "api_key": api_key,
      "token_id": token_id,
      "aadhar": aadhar,
      "methodName": methodName,
    };

    const response = await postRequest({
        url: `${prodBaseUrl}srv2/digital-kyc/aadhar/auto-verification`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error generating OTP:", error.response?.data || error.message);
    throw error;
  }
};

// Verify AadharV2 Resend OTP
export const verifyAadharWithOtpResendV2 = async ({ api_id, api_key, token_id, aadhar, methodName, transactionId,fwdp}) => {
  try {
    const payload = {
        "api_id": api_id,
        "api_key": api_key,
        "token_id": token_id,
        "aadhar": aadhar,
        "methodName": methodName,
        "transactionId": transactionId,
        "fwdp":fwdp,
    };

    const response = await postRequest({
        url: `${prodBaseUrl}srv2/digital-kyc/aadhar/auto-verification`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("Error Resending OTP:", error.response?.data || error.message);
    throw error;
  }
};

// Verify AadharV2
export const verifyAadharWithOtpV2 = async ({ api_id, api_key, token_id, aadhar, methodName, transactionId,fwdp,codeVerifier, otp,shareCode,isSendPdf}) => {
  try {
    const payload = {
        "api_id": api_id,
        "api_key": api_key,
        "token_id": token_id,
        "aadhar": aadhar,
        "methodName": methodName,
        "transactionId": transactionId,
        "fwdp":fwdp,
        "codeVerifier":codeVerifier,
        "otp": otp,
        "shareCode": shareCode,
        "isSendPdf":isSendPdf
    };


    const response = await postRequest({
        url: `${prodBaseUrl}srv2/digital-kyc/aadhar/auto-verification`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    console.error("Error verifying Aadhar with OTP:", error.response?.data || error.message);
    throw error;
  }
};

export const sendDownloadAadharOtp = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}aadhar/download`,
      headers: getAuthHeaders(),
      data: payload,
    });


    return response;
  } catch (error) {
    throw error;
  }
}
export const verifyDownloadAadharOtp = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}aadhar/download`,
      headers: getAuthHeaders(),
      data: payload,
    });


    return response;
  } catch (error) {
    throw error;
  }
}
export const companyCinVerifyService = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}verify/company-cin`,
      headers: getAuthHeaders(),
      data: payload,
    });


    return response;
  } catch (error) {
    throw error;
  }
}
export const itrComplinceCheckService = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}itr/compliance-check`,
      headers: getAuthHeaders(),
      data: payload,
    });


    return response;
  } catch (error) {
    throw error;
  }
}
export const rationCardCheckService = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}verify/ration-card`,
      headers: getAuthHeaders(),
      data: payload,
    });


    return response;
  } catch (error) {
    throw error;
  }
}
export const advanceUpiCheckService = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}upi-verification/advance`,
      headers: getAuthHeaders(),
      data: payload,
    });


    return response;
  } catch (error) {
    throw error;
  }
}
export const simpleUpiCheckService = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}upi-verification/simple`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    throw error;
  }
}
export const BankAccountAnlyscisService = async ({ payload }) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}bank-statement/analysis`,
      headers: getAuthHeaders(),
      data: payload,
    });


    return response;
  } catch (error) {
    throw error;
  }
}
export const BankAccountAnlyscisServiceUpload = async (formData ) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}bank-statement/analysis`,
      headers: { Authorization: `Bearer ${getToken()}`, 'Content-Type': 'multipart/form-data' },
      data: formData,
    });


    return response;
  } catch (error) {
    throw error;
  }
}

export const digitalAadharService = async (payload) => {
  try {
    let response = await postRequest({
      url: `${prodBaseUrl}srv2/digital-kyc/digilocker/kyc`,
      data: payload,
      headers: {
        Authorization: `Bearer ${getToken()}`
      }
    });
    return response;
  } catch (error) {
    return error
  }
}